/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { ContactDetailsCustomerAdditionalDetailsFormState } from './contact-details-customer-additional-details-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-customer-additional-details-tab',
  templateUrl: 'contact-details-customer-additional-details-tab.component.html',
  styleUrls: ['contact-details-customer-additional-details-tab.component.scss'],
})
export class ContactDetailsCustomerAdditionalDetailsTabComponent {

  constructor(public form: ContactDetailsCustomerAdditionalDetailsFormState) {
  }
}
